import {
  whiteSmoke,
  charcoal
} from '@sukiai/components/lib/colors'

export const WEEKDAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']

export const pickerCss = `
.DayPicker {
  font-family: 'Open Sans';
}

.DayPicker-Month {
  table-layout: fixed;
}

.DayPicker-Caption > div {
  color: ${charcoal};
  font-weight: 600;
  cursor: pointer;
}

.DayPicker-Day {
  color: ${charcoal};
  padding: 14px;
}

.DayPicker-Day:hover {
  background-color: ${charcoal} !important;
  color: ${whiteSmoke} !important;
  opacity: 0.85;
}

.DayPicker-Day--selected {
  background-color: ${charcoal} !important;
  color: ${whiteSmoke} !important;
}

.DayPicker-Day--outside {
  opacity: 0.7;
}

.DayPicker-Day--today {
  background-color: #D0D0D0;
  font-weight: 500;
}

.DayPicker-NavButton {
  height: 1.5em;
  width: 1.5em;
}

.DayPicker-NavButton--prev {
  margin-right: 2.2em;
}
`
